import React from 'react';

export const IncrementalModule = React.forwardRef( () => {
  return null;
} );

IncrementalModule.displayName = 'IncrementalModule';

export default IncrementalModule;